// extracted by mini-css-extract-plugin
module.exports = {"numberCircle":"indicator_number_numberCircle__1BCt9"};